import {
  GetAuthorizedEntitiesInput,
  GetAuthorizedEntitiesOutput,
} from '@amzn/coral_com-amazon-carrierlogisticswebserver-model';
import { createAsyncAction } from 'typesafe-actions';
import {
  GET_AUTHORIZED_ENTITIES_FAILURE,
  GET_AUTHORIZED_ENTITIES_REQUEST,
  GET_AUTHORIZED_ENTITIES_SUCCESS,
  GET_AUTHORIZED_LPS_FAILURE,
  GET_AUTHORIZED_LPS_REQUEST,
  GET_AUTHORIZED_LPS_SUCCESS,
  GET_AUTHORIZED_LP_SELECTED_FAILURE,
  GET_AUTHORIZED_LP_SELECTED_REQUEST,
  GET_AUTHORIZED_LP_SELECTED_SUCCESS,
  SET_LP_PICKER_INPUT,
} from './actionTypes';

export const getAuthorizedLps = createAsyncAction(
  GET_AUTHORIZED_LPS_REQUEST,
  GET_AUTHORIZED_LPS_SUCCESS,
  GET_AUTHORIZED_LPS_FAILURE
)();

export const getAuthorizedLpSelected = createAsyncAction(
  GET_AUTHORIZED_LP_SELECTED_REQUEST,
  GET_AUTHORIZED_LP_SELECTED_SUCCESS,
  GET_AUTHORIZED_LP_SELECTED_FAILURE
)();

export const getAuthorizedEntities = createAsyncAction(
  GET_AUTHORIZED_ENTITIES_REQUEST,
  GET_AUTHORIZED_ENTITIES_SUCCESS,
  GET_AUTHORIZED_ENTITIES_FAILURE
)<GetAuthorizedEntitiesInput, GetAuthorizedEntitiesOutput, string>();


export function setLpPickerInput(payload: Array<string> | string) {
  return {
    type: SET_LP_PICKER_INPUT,
    payload,
  };
}
